/**
 * Mobile Menu open and closing menu and submenus.
 */
export default function mobileMenu() {
  Array
    .from( document.querySelectorAll( '.js-mobile-menu > .menu-item-has-children > .menu-item-link' ) )
    .forEach( parentLink => main( parentLink ) )

  /**
   * Functionality for toggling a submenu.
   *
   * @param {object} parentLink Link that triggers a submenu.
   */
  function main( parentLink ) {
    const parentMenuContainer = parentLink.parentElement
    const submenuContainer = parentMenuContainer.querySelector( '.js-sub-menu-container' )

    parentLink.addEventListener( 'click', event => {
      event.preventDefault()
      slideContainer( submenuContainer )
    })

    parentMenuContainer
      .querySelector( '.js-mobile-menu-back' )
      .addEventListener( 'click', () => {
        slideContainer( submenuContainer )
      })

    parentMenuContainer
      .querySelector( '.js-mobile-menu-close' )
      .addEventListener( 'click', () => {
        slideContainer( submenuContainer )
      })
  }

  /**
   * Slide in or out a div container.
   *
   * @param {object} container The container to slide in or out.
   */
  function slideContainer( container ) {
    container.classList.toggle( 'invisible' )
    container.classList.toggle( 'left-100%' )
    container.classList.toggle( 'left-0' )
  }
}
